// Permission utility functions

export const canDelete = (user) => {
  if (!user) return false;
  return user.role === 'Super Admin' || user.role === 'Admin';
};

export const canEdit = (user) => {
  if (!user) return false;
  return user.role === 'Super Admin' || user.role === 'Admin';
};

export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === 'Super Admin') return true;
  if (user.permissions && user.permissions.includes('all')) return true;
  if (user.permissions && user.permissions.includes(permission)) return true;
  return false;
};
